import { render, staticRenderFns } from "./BoardCommentList.vue?vue&type=template&id=80582298&"
import script from "./BoardCommentList.vue?vue&type=script&lang=js&"
export * from "./BoardCommentList.vue?vue&type=script&lang=js&"
import style0 from "./BoardCommentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports